module.exports = {"name":"notes","items":[{"name":"notes_additional-notes","text":"Are there any additional notes you would like us to know prior to your intake call?","type":"textarea","props":{"label":"Additional Notes","maxLength":"400"},"id":"b68cd895-6f9d-4351-b60b-9ced7eac46b9"}],"id":"5d1dc669-9ce4-48f3-9bca-0c383ea94ffa","section":"Additional Notes"}


//////////////////
// WEBPACK FOOTER
// ./src/components/contingency-elite/valuation-data/notes.json
// module id = 2a8C
// module chunks = 0